import { render } from "./BloodDrawView.vue?vue&type=template&id=101b891e&scoped=true"
import script from "./BloodDrawView.vue?vue&type=script&lang=js"
export * from "./BloodDrawView.vue?vue&type=script&lang=js"

import "./BloodDrawView.vue?vue&type=style&index=0&id=101b891e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101b891e"]])

export default __exports__